export default __webpack_public_path__ + "static/media/supply-demand-equilibrium.ee1faf1d.png";